import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Col,
    UncontrolledPopover,
    PopoverBody
} from 'reactstrap';
import {Redirect} from "react-router-dom";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Utils} from '../../../utils/utils';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import InputWithPopover
    from './../../accreditationManagement/validateAccreditation/inputWithPopover/InputWithPopover.container';
import './ValidatePendingAccreditation.css';
import ValidatePendingAccreditationModal
    from "./../validatePendingAccreditationModal/ValidatePendingAccreditationModal.container";
import DiscardPendingAccreditationModal
    from "./../discardPendingAccreditationModal/DiscardPendingAccreditationModal.container";
import PageNotFoundComponent from '../../commonComponents/pageNotFoundComponent/PageNotFoundComponent.container';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import IconContainer from '../../commonComponents/iconContainer/IconContainer';

class ValidatePendingAccreditation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            personContinent: this.props.continentCode,
            message: '',
            fieldErrors: {}
        };
    };

    componentWillMount() {
        this.props.onGetVIDs(this.props.id);
        if (!_.isNil(this.props.data)) {
            this.props.onGetLevels(this.props.data.accreditationGroupId);
            this.props.onContinentSetByCountry(this.props.data.personCountry);
        }
    };

    componentWillReceiveProps(nextProps) {
        if (this.state.personContinent !== nextProps.continentCode) {
            this.setState({personContinent: nextProps.continentCode})
        }
        if (_.isNil(this.props.data) && !_.isNil(nextProps.data)) {
            this.props.onContinentSetByCountry(nextProps.data.personCountry);
        }
    };

    componentWillUnmount() {
        this.props.onContinentSet('');
    };

    render() {
        if (this.props.success) {
            return <Redirect to="/pending-accreditations" push/>;
        }

        if (_.isNil(this.props.id) || _.isNil(this.props.data)) {
            return <PageNotFoundComponent/>;
        }

        if (this.props.loading) {
            return (
                <div className="validate-pending-accreditation-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        return (
            <div className="validate-pending-accreditation-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'validate_accreditation.success_message')}>
                    <BackButtonComponent path="/pending-accreditations"
                                         label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <div className="validate-pending-accreditation-form">
                        <h4 className='page-label'>{_.get(this.props.translation, 'validate_accreditation.label')}</h4>
                        {this.renderContent()}
                    </div>
                </FormWrapper>
                <ValidatePendingAccreditationModal onAcceptAccreditation={this.onValidateAccreditation}/>
                <DiscardPendingAccreditationModal onDiscardAccreditation={this.onDiscardAccreditation}/>
            </div>
        );
    };

    renderOrganizationData = () => {
        return (
            <div className="validate-pending-accreditation-org-data">
                <h6>{_.get(this.props.translation, 'applicant_accreditations_management.issued_by_label') + ":"}</h6>
                <span>{this.props.data.issuedByName + ', ' + _.get(this.props.translation, 'countries.' + this.props.data.issuedByCountry)}</span>
            </div>
        )
    };

    renderContent = () => {
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }

        if (!_.isNil(this.props.data) && !_.isNil(this.props.isVIDEditable)) {
            return (
                <Form onSubmit={this.onSubmit}>
                    {this.renderOrganizationData()}
                    <FormGroup row className="accreditation-data-form-group">
                        <Col sm={7}>
                            <h5>{_.get(this.props.translation, 'accreditation.accreditation_label')}</h5>
                            {this.renderTitlesFormGroups()}
                            {this.renderAdditionalTitlesFormGroups()}
                            {this.renderAccreditationFormGroups()}
                        </Col>
                        <Col sm={5}>
                            <h5>{_.get(this.props.translation, 'accreditation.person_label')}</h5>
                            {this.renderPersonFormGroups()}
                        </Col>
                    </FormGroup>

                    {this.renderSubmitFormGroup()}
                </Form>
            );
        } else {
            return null;
        }
    };

    renderTitlesFormGroups = () => {
        let paramsList = [
            {
                value: "titleOrig",
                title: _.get(this.props.translation, 'accreditation.accreditation_title_orig_label') + "*",
            },
            {
                value: "titleEn",
                title: _.get(this.props.translation, 'accreditation.accreditation_title_en_label') + "*",
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderAdditionalTitlesFormGroups = () => {
        let title = <h6
            key="additional-langs-title">{_.get(this.props.translation, 'accreditation.additional_translations_label')}</h6>;
        let paramsList = [];

        _.mapValues(this.props.data.titlesAdditional, (value, key) => {
            let oldValue = (this.props.data.original.titlesAdditional && this.props.data.original.titlesAdditional[key] ?
                this.props.data.original.titlesAdditional[key] : value);
            paramsList.push({
                value: key,
                title: _.get(this.props.translation, 'langs.' + key),
                oldValue: oldValue,
                proposedValue: this.fieldErrorsHasValue(key) ? this.state.fieldErrors[key].value : value,
                newValueText: value,
            });
        });

        let result = [..._.map(paramsList, this.getFormGroup)];
        return result.length !== 0 ? [title, ...result] : null;
    };

    renderAccreditationFormGroups = () => {
        let content = Utils.getLevelsOptions(
            this.props.levels,
            _.get(this.props.translation, 'levels')
        );
        let selectedOption = _.find(content, option =>
            this.fieldErrorsHasValue('level') ? option.value === this.state.fieldErrors['level'].value : option.value === this.props.data['level']
        );

        let oldValue = this.originalDataHasValue('level') ? this.props.data.original.level : this.props.data.level;
        let params = {
            value: "level",
            title: _.get(this.props.translation, 'accreditation.level_label') + "*",
            type: 'select',
            oldValue: oldValue,
            oldValueText: _.get(this.props.translation, 'levels.' + oldValue),
            proposedValueText: this.fieldErrorsHasValue('level') ? _.get(this.props.translation, 'levels.' + this.state.fieldErrors.level.value) : '',
            newValueText: _.get(this.props.translation, 'levels.' + this.props.data.level),
            popoverPlacement: 'left',
            componentType: Select,
            componentProps: {
                options: content,
                selectedOption: selectedOption,
                isSearchable: false,
                onSelect: this.handleChangeProposedValue("level"),
                placeholder: _.get(this.props.translation, 'accreditation.level_input_placeholder')
            }
        };

        return [this.renderDateIssued(), this.getFormGroup(params)];
    };

    renderDateIssued = () => {
        let params = {
            value: "dateIssued",
            className: 'date-issued-input',
            title: _.get(this.props.translation, 'accreditation.date_issued_label') + "*",
            oldValueText: (this.originalDataHasValue('dateIssued') ? this.props.data.original : this.props.data).dateIssued.format("L"),
            proposedValueText: this.fieldErrorsHasValue('dateIssued') ? this.state.fieldErrors.dateIssued.value.format("L") : '',
            newValueText: moment(this.props.data.dateIssued).format('L'),
            componentType: DatePicker,
            componentProps: {
                customInput: <Input
                    id='date-issued'
                />,
                showMonthDropdown: true,
                showYearDropdown: true,
                dropdownMode: "select",
                maxDate: moment()
            },
            popoverPlacement: 'left'
        };
        return this.getFormGroup(params);
    };

    renderPersonFormGroups = () => {
        let countries = Utils.getLocationOptions(
            this.props.countries,
            _.get(this.props.translation, sharedLabelsPath.countries)
        );
        let selectedCountry = _.find(countries, option =>
            this.fieldErrorsHasValue('personCountry') ? option.value === this.state.fieldErrors['personCountry'].value
                : option.value === this.props.data['personCountry']
        );
        let paramsList = [
            {
                value: "personFirstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label) + "*",
            },
            {
                value: "personLastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label) + "*",
            },
            {
                value: "personNationalId",
                title: _.get(this.props.translation, sharedLabelsPath.national_id_label) + "*",
                popoverHintParams: {
                    hintText: _.get(this.props.translation, 'accreditation_requests.national_id_hint')
                }
            },
            {
                value: "personCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label) + "*",
                type: 'select',
                componentType: Select,
                componentProps: {
                    options: countries,
                    isSearchable: false,
                    placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                    onSelect: this.handleChangeProposedValue("personCountry"),
                    selectedOption: selectedCountry
                }
            }
        ];

        if (this.props.isVIDEditable) {
            return [..._.map(paramsList, this.getFormGroup)];
        } else {
            return [..._.map(paramsList, this.getNotEditableFormGroup)];
        }
    };

    getNotEditableFormGroup = (params) => {
        if (_.isNil(params) || typeof (params) !== 'object') {
            return;
        }

        let value;

        if (params.value === "personCountry") {
            value = _.get(this.props.translation, sharedLabelsPath.countries + "." + this.props.data[params.value])
        } else {
            value = this.props.data[params.value];
        }

        return (
            <FormGroup row key={params.title}>
                <Label sm={4}>
                    {params.title}
                    {this.renderHintPopover(params.value, params.popoverHintParams)}
                </Label>
                <Label sm={8}>{value}</Label>
            </FormGroup>
        );
    };

    getFormGroup = (params) => {
        if (_.isNil(params) || typeof (params) !== 'object') {
            return;
        }

        let id = _.kebabCase(params.value);

        if (params.value === "personCountry") {
            return this.renderContinentAndCountryComponent(params);
        }

        let oldValue = this.props.data[params.value];
        if (!_.isNil(params.oldValue)) {
            oldValue = params.oldValue
        } else if (_.has(this.props.data.original, params.value)) {
            oldValue = this.props.data.original[params.value];
        }

        return (
            <FormGroup row key={params.title}>
                <Label sm={3}>
                    {params.title}
                    {this.renderHintPopover(params.value, params.popoverHintParams)}
                </Label>
                <Col sm={9}>
                    <InputWithPopover
                        id={id}
                        className={params.className || ''}
                        popoverPlacement={params.popoverPlacement}
                        editMode={this.fieldErrorsHasValue(params.value)}
                        oldValue={oldValue}
                        proposedValue={params.proposedValue || (this.fieldErrorsHasValue(params.value) ? this.state.fieldErrors[params.value].value : this.props.data[params.value])}
                        newValueText={params.newValueText || this.props.data[params.value]}
                        message={this.fieldErrorsHasValue(params.value) ? this.state.fieldErrors[params.value].reason : null}
                        onChangeProposedValue={this.handleChangeProposedValue(params.value)}
                        onChangeMessage={this.handleChangeMessage(params.value)}
                        onChangeToggle={this.handleChangeFieldErrors(params.value)}
                        type={params.type || 'text'}
                        oldValueText={params.oldValueText}
                        proposedValueText={params.proposedValueText}
                        componentType={params.componentType}
                        componentProps={params.componentProps}
                    >
                        {params.content}
                    </InputWithPopover>
                </Col>
            </FormGroup>
        );

    };

    renderHintPopover = (fieldName, params) => {
        if (!_.isNil(params)) {
            return (
                <div className="validate-pending-accreditation-hint-container">
                    <span id={fieldName + '-hint'} className='validate-pending-accreditation-hint-icon-container'>
                        <IconContainer 
                            icon='question_mark'
                            title={_.get(this.props.translation, sharedLabelsPath.about_label)}
                        />
                    </span>
                    <UncontrolledPopover trigger="legacy" placement="top" target={fieldName + '-hint'}>
                        <PopoverBody>
                            <div>
                                {Utils.getTagsFromStringWithStyles(params.hintText)}
                            </div>
                        </PopoverBody>
                    </UncontrolledPopover >
                </div>
            );
        }
    };

    fieldErrorsHasValue = (value) => {
        return _.has(this.state.fieldErrors, `${value}`)
    };

    originalDataHasValue = (value) => {
        return _.has(this.props.data.original, value);
    }

    renderSubmitFormGroup = () => {
        return [
            <FormGroup row className="reject-message" key="reject-message">
                <Col sm={7} className="textarea-col">
                    <FormGroup>
                        <Label>{_.get(this.props.translation, 'validate_accreditation.common_message_label')}</Label>
                        <Input type="textarea"
                               value={this.state.message}
                               onChange={this.handleChange("message")}
                               placeholder={_.get(this.props.translation, 'validate_accreditation.common_message_placeholder')}
                        />
                    </FormGroup>
                </Col>
            </FormGroup>,
            <FormGroup row key="submit-validation-pending-accreditation-btns">
                <Col sm={12} className="submit-validation-pending-accreditation-btns">
                    <Button
                        onClick={this.onSendBackToReview}
                        title={this.isAccreditationEdited() ? "" : _.get(this.props.translation, 'validate_accreditation.submit_button_invalidate_title')}
                        disabled={!this.isAccreditationEdited()}
                    >
                        {_.get(this.props.translation, "applicant_accreditations_management.send_back_accreditation_button_label")}
                    </Button>
                    <div>
                        <Button className="discard-pending-accreditation-button carrot-red-btn"
                                onClick={this.onDiscardButtonClick}>{_.get(this.props.translation, "applicant_accreditations_management.discard_accreditation_button_label")}</Button>
                        <Button type="submit"
                                className="olive-green-btn">{_.get(this.props.translation, "applicant_accreditations_management.accept_accreditation_button_label")}</Button>
                    </div>
                </Col>
            </FormGroup>
        ]
    };

    isAccreditationEdited = () => {
        return !_.isEmpty(this.state.fieldErrors) || this.state.message !== '';
    };

    renderContinentAndCountryComponent(params) {
        let id = _.kebabCase(params.value);
        let proposedValueText = _.isNil(this.state.fieldErrors[params.value]) ? null :
            _.get(this.props.translation, sharedLabelsPath.countries + "." + this.state.fieldErrors[params.value].value);
        let continents = Utils.getLocationOptions(
            this.props.continents,
            _.get(this.props.translation, sharedLabelsPath.continents)
        );
        let selectedContinent = _.find(continents, option => option.value === this.state.personContinent);
        let oldValue = (this.originalDataHasValue(params.value) ? this.props.data.original : this.props.data)[params.value];

        return [
            <FormGroup row key="continent-select" className="continent-select-container">
                <Label for="continent-select"
                       sm={3}>{_.get(this.props.translation, sharedLabelsPath.continent_filter_label)}</Label>
                <Col sm={9}>
                    <FormGroup row className="continent-select-form-group">
                        <Col sm={11}>
                            <Select
                                selectedOption={selectedContinent}
                                options={continents}
                                onSelect={this.handleChangeContinent}
                                placeholder={_.get(this.props.translation, sharedLabelsPath.continent_input_placeholder)}
                                disabled={_.isNil(this.props.continents) && !this.fieldErrorsHasValue(params.value)}
                            />
                        </Col>
                    </FormGroup>
                </Col>
            </FormGroup>,
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <InputWithPopover
                        id={id}
                        type='select'
                        popoverPlacement='left'
                        editMode={this.fieldErrorsHasValue(params.value)}
                        oldValue={oldValue}
                        oldValueText={_.get(this.props.translation, 'countries.' + oldValue)}
                        proposedValue={this.fieldErrorsHasValue(params.value) ? this.state.fieldErrors[params.value].value : null}
                        proposedValueText={proposedValueText}
                        newValueText={_.get(this.props.translation, 'countries.' + this.props.data[params.value])}
                        message={this.fieldErrorsHasValue(params.value) ? this.state.fieldErrors[params.value].reason : null}
                        onChangeProposedValue={this.handleChangeProposedValue(params.value)}
                        onChangeMessage={this.handleChangeMessage(params.value)}
                        onChangeToggle={this.handleChangeFieldErrors(params.value)}
                        componentType={params.componentType}
                        componentProps={
                            {
                                ...params.componentProps,
                                disabled: this.fieldErrorsHasValue(params.value) && (this.state.personContinent === '' || _.isNil(this.props.countries))
                            }
                        }>
                        {params.content}
                    </InputWithPopover>
                </Col>
            </FormGroup>
        ];
    };

    getNewValue = (fieldKey) => {
        if (this.fieldErrorsHasValue(fieldKey)) {
            return this.state.fieldErrors[fieldKey].value;
        }
        return this.props.data[fieldKey];
    }

    onSendBackToReview = () => {
        let titles = {
            original: this.getNewValue('titleOrig'),
            en: this.getNewValue('titleEn')
        };
        _.forEach(this.props.data.titlesAdditional, (title, lang) => {
            if (lang !== "" && title !== "") {
                titles[lang] = this.fieldErrorsHasValue(lang) ? this.state.fieldErrors[lang].value : this.props.data.titlesAdditional[lang];
            }
        });

        let data = {
            accreditationData: {
                issuedAt: this.getNewValue('dateIssued').format("YYYY-MM-DD"),
                level: this.getNewValue('level'),
                titles: titles
            },
            verifiedIdentity: {
                firstName: this.getNewValue('personFirstName'),
                lastName: this.getNewValue('personLastName'),
                countryCode: this.getNewValue('personCountry'),
                nationalId: this.getNewValue('personNationalId')
            },
            answer: {
                message: this.state.message,
                fieldErrors: _.cloneDeep(this.state.fieldErrors),
                accepted: false
            }
        }

        if (this.fieldErrorsHasValue('dateIssued')) {
            data.answer.fieldErrors.dateIssued.value = data.answer.fieldErrors.dateIssued.value.format("YYYY-MM-DD");
        }

        this.props.onSubmit(this.props.id, data);
    };

    onDiscardButtonClick = () => {
        this.props.onOpenDiscardPendingAccreditationModal();
    };

    onDiscardAccreditation = () => {
        this.props.onDiscard(this.props.id);
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (_.isEmpty(this.state.fieldErrors)) {
            this.onValidateAccreditation();
        } else {
            this.props.onOpenValidatePendingAccreditationModal();
        }
    };

    onValidateAccreditation = () => {

        let data = {
            answer: {
                accepted: true
            }
        };

        this.props.onSubmit(this.props.id, data);
    };

    handleChangeMessage = (fieldKey) => (e) => {
        let newFieldErrors = this.state.fieldErrors;

        newFieldErrors[fieldKey].reason = e.target.value;

        this.setState({fieldErrors: newFieldErrors});
    };

    handleChangeProposedValue = (fieldKey) => (e) => {
        if (_.isNil(e)) {
            return;
        }

        let newValue;
        if (fieldKey === "dateIssued") {
            newValue = e;
        } else {
            newValue = e.value || e.target.value;
        }

        let newFieldErrors;
        if (_.isEqual(newValue, this.props.data[fieldKey])
            || (_.isNil(this.props.data[fieldKey]) && _.isEqual(newValue, this.props.data.titlesAdditional[fieldKey]))) {
            newFieldErrors = _.omit(this.state.fieldErrors, fieldKey);
        } else {
            newFieldErrors = this.state.fieldErrors;
            if (_.isNil(newFieldErrors[fieldKey])) {
                newFieldErrors[fieldKey] = {value: null, reason: ""};
            }
            newFieldErrors[fieldKey].value = newValue;
        }

        this.setState({fieldErrors: newFieldErrors});
    };

    handleChangeFieldErrors = (fieldKey) => () => {
        let newFieldErrors;

        if (this.fieldErrorsHasValue(fieldKey)) {
            newFieldErrors = _.pickBy(this.state.fieldErrors, (value, key) => {
                return key !== fieldKey;
            });
            if (fieldKey === "personCountry") {
                this.props.onContinentSetByCountry(this.props.data.personCountry);
            }
        } else {
            newFieldErrors = this.state.fieldErrors;
            newFieldErrors[fieldKey] = {
                value: this.props.data[fieldKey] || this.props.data.titlesAdditional[fieldKey],
                reason: ""
            }
        }

        this.setState({fieldErrors: newFieldErrors});
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeContinent = (e) => {
        let newFieldErrors = this.state.fieldErrors;

        newFieldErrors.personCountry = {};
        newFieldErrors.personCountry.value = "";
        this.setState({fieldErrors: newFieldErrors});

        this.props.onContinentSet(e.target.value);
    };
}

ValidatePendingAccreditation.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    levels: PropTypes.array,
    isVIDEditable: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onDiscard: PropTypes.func.isRequired,
    onContinentSet: PropTypes.func.isRequired,
    onContinentSetByCountry: PropTypes.func.isRequired,
    onGetLevels: PropTypes.func.isRequired,
    onGetVIDs: PropTypes.func.isRequired,
    onOpenValidatePendingAccreditationModal: PropTypes.func,
    onOpenDiscardPendingAccreditationModal: PropTypes.func
};

export default ValidatePendingAccreditation;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/validatePendingAccreditation/ValidatePendingAccreditation.js